import React from "react";

function Loader() {
  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center gap-2">
        <div id="loader_spin" className="loader_main_page">
          <span className="loader"></span>
        </div>
        <p className="loader_p">Still Processing...</p>
      </div>
    </div>
  );
}

export default Loader;
